import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Pillars from "./components/Pillars";
import Stratflow from "./components/Stratflow";
import Services from "./components/Services";
import Cases from "./components/Cases";
import Clients from "./components/Clients";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StratflowPage from "./pages/Stratflow";
import Presentation from "./pages/Presentation";
import { Toaster } from "./components/ui/sonner";
import usePageMeta from "./hooks/usePageMeta";

const SITE = "https://strategy-landing-hub.emergent.host";

const Landing = () => {
  usePageMeta({
    title: "GT Strategy - Evoluímos negócios, transformamos culturas.",
    description:
      "GT Strategy é a consultoria de estratégia, excelência operacional, digitalização e cultura por trás de mais de 45 projetos de transformação desde 2017. Metodologia proprietária STRATFLOW®.",
    canonical: `${SITE}/`,
    image: `${SITE}/brand/logo-gt-slogan.svg`,
    type: "website",
    ldJson: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "GT Strategy",
      url: SITE,
      logo: `${SITE}/brand/logo-gt-slogan.svg`,
      foundingDate: "2017",
      description:
        "Consultoria de estratégia, excelência operacional, digitalização e cultura. Metodologia proprietária STRATFLOW®.",
      sameAs: ["https://www.linkedin.com/company/gtstrategy/"],
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: "contato@gtstrategy.com.br",
          areaServed: "BR",
          availableLanguage: ["Portuguese", "English"],
        },
      ],
    },
  });

  return (
    <main className="bg-gt-bg text-gt-ink min-h-screen overflow-x-hidden">
      <Header />
      <Hero />
      <Pillars />
      <Services />
      <Stratflow />
      <Cases />
      <Clients />
      <Contact />
      <Footer />
    </main>
  );
};

const PresentationNewRedirect = () => {
  React.useEffect(() => {
    window.location.replace("/presentation-new/index.html");
  }, []);
  return null;
};

const AssetOpsRedirect = () => {
  React.useEffect(() => {
    window.location.replace("/assetops/index.html");
  }, []);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/stratflow" element={<StratflowPage />} />
            <Route path="/presentation" element={<Presentation />} />
            <Route path="/presentation-new" element={<PresentationNewRedirect />} />
            <Route path="/presentatio-new" element={<PresentationNewRedirect />} />
            <Route path="/assetops" element={<AssetOpsRedirect />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
